import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table          : 'CI_PROPERTY_RESOLVED',
    fieldMap       : {
        id              : 'CIP_ID',
        key             : 'CIP_KEY',
        value           : 'CIP_VALUE',
        itemId          : 'CIP_CI_ID',
        propertySetId   : 'CIP_CIPS_ID',
        statusId        : 'CIP_CIST_ID',
        modifierUserId  : 'CIP_MODIFIER',
        modificationTime: 'CIP_MODIFICATION_TIME',
        validatorUserId : 'CIP_VALIDATOR',
        validationTime  : 'CIP_VALIDATION_TIME',
        label           : 'CIV_LABEL'
    },
    historyFieldMap: {},
    fieldTypesMap  : {
        id              : 'INTEGER',
        key             : 'STRING',
        value           : 'STRING',
        itemId          : 'INTEGER',
        propertySetId   : 'INTEGER',
        statusId        : 'INTEGER',
        modifierUserId  : 'STRING',
        modificationTime: 'TIMESTAMP',
        validatorUserId : 'STRING',
        validationTime  : 'TIMESTAMP',
        label           : 'STRING'
    }
};

export default tableDefinition;
